import { render, staticRenderFns } from "./ReplacementEdit.html?vue&type=template&id=4563bc41&external"
import script from "./ReplacementEdit.ts?vue&type=script&lang=ts&external"
export * from "./ReplacementEdit.ts?vue&type=script&lang=ts&external"
import style0 from "./ReplacementEdit.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports